import React from 'react';

import SkeletonBlock from 'dpl/common/design_system/SkeletonBlock';
import { makeSequence } from 'dpl/shared/utils';

export default function WorkingWithBreederSectionSkeleton() {
  return (
    <div className="WorkingWithBreederSectionSkeleton">
      <div className="container-xxl mv4">
        <SkeletonBlock className="font-24 mb6" height="1em" width="10em" />
        <div className="pv6">
          {makeSequence(3).map(index => (
            <SkeletonBlock
              className="br12 mb2"
              height="4em"
              width="100%"
              key={index}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
